module.exports = __webpack_public_path__ + "img/1.1d18d49e.webp";